import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Button from '../button';
import CheckBox from '../check-box-group/check-box';
import ColumnContainer from '../layouts/components/column-container';
import FluidContainer from '../layouts/components/fluid-container';

import { getRedirectToSource } from '../../lib/utils';

import { SOURCES } from '../../constants/sources';
import DOMPurify from 'dompurify';

export const Link = styled.a`
    color: var(--blue500);
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
`;

const ClassWorkPrivacyConsent = ({ setPrivacyConsent }) => {
    const [privacyAccepted, setPrivacyAccepted] = useState(false);

    const Title = styled.div`
        font-size: 28px;
        font-weight: 300;
        line-height: 36px;
    `;

    const ButtonsContainer = styled.div`
        display: flex;
        margin-top: 32px;

        & > button {
            margin-right: 16px;
        }

        @media (max-width: 767px) {
            flex-direction: column;

            & > button {
                width: 100%;
                margin-right: 0;
                margin-top: 16px;
            }

            & > a {
                width: 100%;
                margin-right: 0;
                margin-top: 16px;
            }
        }
    `;

    const onButtonClick = () => {
        setPrivacyConsent();
    };

    return (
        <FluidContainer paddingTop={80} paddingBottom={80} flexDirection="column">
            <ColumnContainer width={[1, 2 / 3, 6 / 12]} paddingLeft={24} paddingRight={24}>
                <div>
                    <Title>{'Dai a Zanichelli il consenso al trattamento dei dati'}</Title>
                    <p>
                        {'Zanichelli ha bisogno del tuo consenso per salvare il tuo Google ID.'}
                        <br />
                        {'Ci serve per:'}
                    </p>
                    <ul>
                        <li>{'salvare i risultati delle prove che svolgerai su ZTE,'}</li>
                        <li>{'inviare al tuo insegnante su Google Classroom le prove svolte e i risultati.'}</li>
                    </ul>
                    <p>
                        {
                            'Useremo il tuo Google ID solo per il servizio ZTE: non lo condivideremo con altri né lo useremo per altri scopi. Non salviamo il tuo indirizzo email né le tue informazioni personali. '
                        }
                    </p>
                    <p>
                        {'Vuoi più informazioni? '}
                        <Link target="_blank" href="https://my.zanichelli.it/privacy">
                            {'Leggi le linee di condotta di Zanichelli sulla privacy.'}
                        </Link>
                    </p>
                    <CheckBox
                        name="privacy-consent"
                        value={1}
                        checked={privacyAccepted}
                        onChange={(event) => setPrivacyAccepted(event.target.checked)}
                    >
                        {'Acconsento alla raccolta e al trattamento dei dati da parte di Zanichelli per usare i servizi ZTE. '}
                    </CheckBox>
                    <ButtonsContainer>
                        <Button disabled={!privacyAccepted} onClick={() => onButtonClick()}>
                            {'Accetta e continua'}
                        </Button>
                        <Button
                            type="tertiary"
                            as="a"
                            disabled={false}
                            href={DOMPurify.sanitize(getRedirectToSource(SOURCES.GOOGLE_CLASSROOM))}
                        >
                            {'Annulla e torna a Classroom'}
                        </Button>
                    </ButtonsContainer>
                </div>
            </ColumnContainer>
        </FluidContainer>
    );
};

ClassWorkPrivacyConsent.propTypes = {
    setPrivacyConsent: PropTypes.func,
};

export default ClassWorkPrivacyConsent;
